export default __webpack_public_path__ + "static/media/tyoko.2ce17a32.jpg";